module.exports = __webpack_public_path__ + "images/ferrari5b6ccd4b0ba6cf7a6d4928a2daff65ef.png";